// RITA-1498 (Nutzungserfassung Phase 1b) — Art der Navigation und Bedien-Hinweise (Konzept 3.3).
// Der Router kennt nur POP/PUSH/REPLACE. Ob ein PUSH aus dem Menü, aus einem Link in der Seite
// oder programmatisch (z. B. nach dem Speichern) kam, ergibt sich aus dem letzten Klick kurz davor.
export type NavType = 'menu' | 'link' | 'direct' | 'back' | 'redirect';
// Werte von react-router useNavigationType(): 'POP' | 'PUSH' | 'REPLACE' (als string, weil Enum).
export type RouterNavigationType = string;

export const CLICK_NAV_WINDOW_MS = 1500;

export interface ClickHint {
  at: number;
  inNav: boolean;
}

export interface DecideNavTypeInput {
  isFirst: boolean;
  navigationType: RouterNavigationType;
  lastClick: ClickHint | null;
  now: number;
}

export const decideNavType = ({ isFirst, navigationType, lastClick, now }: DecideNavTypeInput): NavType => {
  if (isFirst) return 'direct';
  if (navigationType === 'POP') return 'back';
  if (navigationType === 'REPLACE') return 'redirect';
  if (lastClick && now - lastClick.at <= CLICK_NAV_WINDOW_MS) return lastClick.inNav ? 'menu' : 'link';
  return 'redirect';
};

export interface InteractionHints {
  noteClick(hint: ClickHint): void;
  lastClick(): ClickHint | null;
  /** Erste Bedienhandlung (Klick/Taste): davor sind Einstellungsänderungen Initialisierung. */
  noteInteraction(): void;
  hasInteracted(): boolean;
}

export const createInteractionHints = (): InteractionHints => {
  let last: ClickHint | null = null;
  let interacted = false;
  return {
    noteClick(hint: ClickHint): void {
      last = hint;
      interacted = true;
    },
    lastClick: () => last,
    noteInteraction(): void {
      interacted = true;
    },
    hasInteracted: () => interacted,
  };
};
